// ─── Spot ─────────────────────────────────────────────────────────────────────

export const MAX_SPOTS_PER_USER = 4;

export const SPOT_STATUS = {
  FREE:        'free',
  OCCUPIED:    'occupied',
  UNAVAILABLE: 'unavailable',
} as const;

// ─── Session ──────────────────────────────────────────────────────────────────

export const SESSION_ERRORS = {
  SPOT_NOT_FREE:      'SPOT_NOT_FREE',
  SESSION_EXISTS:     'SESSION_EXISTS',
  SESSION_NOT_FOUND:  'SESSION_NOT_FOUND',
  NOT_YOUR_SESSION:   'NOT_YOUR_SESSION',
} as const;

// ─── Reclaim ──────────────────────────────────────────────────────────────────

export const RECLAIM_COOLDOWN_MINUTES = 10;

export const RECLAIM_STATUS = {
  PENDING:      'pending',
  ACKNOWLEDGED: 'acknowledged',
  RESOLVED:     'resolved',
  CANCELLED:    'cancelled',
} as const;

// ─── Availability ─────────────────────────────────────────────────────────────

export const DAYS_OF_WEEK = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
} as const;

export const DAY_LABELS: Record<number, string> = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

// ─── Levels (gamification) ─────────────────────────────────────────────────────
// Milestone levels 1-7 are one-time "did you try this" achievements; levels
// 8-10 are cumulative lifetime-owner-session-count tiers. Titles/descriptions
// live in i18n (web/src/translations/Levels.json), never duplicated here —
// this is just the ordered list of level numbers + stable keys.
//
// web consumes these as real runtime values (Vite bundles this package
// fine). api does NOT — it can only use @lotngo/shared as a type source
// (import type, erased at compile time); a runtime import crashes with
// ERR_REQUIRE_ESM since shared's build isn't part of the API's Docker
// image. api/src/services/levelService.ts mirrors these constants locally —
// keep both copies in sync by hand, same as lib/notificationTopics.ts.

export const LEVELS = [
  { level: 1,  key: 'registered' },
  { level: 2,  key: 'first_share' },
  { level: 3,  key: 'regular' },
  { level: 4,  key: 'responder' },
  { level: 5,  key: 'hands_free_sharer' },
  { level: 6,  key: 'flexible_neighbor' },
  { level: 7,  key: 'multi_spot_host' },
  { level: 8,  key: 'trusted_sharer' },
  { level: 9,  key: 'go_to_neighbor' },
  { level: 10, key: 'community_pillar' },
] as const;

export const MAX_LEVEL = 10;

// Session-count thresholds for the cumulative tiers (levels 8-10).
export const SESSION_COUNT_LEVEL_THRESHOLDS: Record<number, number> = {
  8:  5,
  9:  15,
  10: 25,
};

// ─── API ──────────────────────────────────────────────────────────────────────

export const API_BASE_PATH = '/api/v1';

export const WS_EVENTS = {
  SPOT_STATUS_CHANGED:  'spot.status_changed',
  SESSION_STARTED:      'session.started',
  SESSION_ENDED:        'session.ended',
  RECLAIM_ALERT_SENT:   'reclaim.alert_sent',
  RECLAIM_ACKNOWLEDGED: 'reclaim.acknowledged',
  WINDOW_CREATED:       'window.created',
  WINDOW_CLOSED:        'window.closed',
} as const;
